<div class="mt-responsive">
<app-filter (search)="getPropiedades($event)"></app-filter>

<div class="container" >

  <!-- Botones de cambio de vista -->
  <div class="text-center mb-3 mt-3">
    <button class="btn btn-outline-primary mx-1"
            [class.active]="viewMode === 'list'"
            (click)="setView('list')">
      <i class="fas fa-list"></i> Lista
    </button>

    <button class="btn btn-outline-primary mx-1"
            [class.active]="viewMode === 'map'"
            (click)="setView('map')">
      <i class="fas fa-map"></i> Mapa
    </button>
  </div>

  <!-- Loading / errores -->
  <app-loading *ngIf="loading"></app-loading>
  <app-alert *ngIf="error"></app-alert>

  <!-- Mensaje si no hay propiedades -->
  <div class="row animated fadeIn fast" *ngIf="propiedades.length==0 && !loading">
    <div class="col-md-12">
      <div class="alert alert-info" role="alert">
        No existen propiedades
      </div>
    </div>
  </div>

  <!-- Vista según selección -->
  <ng-container *ngIf="viewMode === 'list'">
    <app-card [propiedades]="propiedades"></app-card>
  </ng-container>

  <ng-container *ngIf="viewMode === 'map'">
    <app-map [propiedades]="propiedades">
</app-map>

  </ng-container>

</div>
</div>